module.exports = __webpack_public_path__ + "img/w4_02.e28be59d.jpg";